import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeListItemWire } from './types';
import { Value } from 'app/types-shared';

const mergePathWithList = (codes: CodeComplexValue<number>[], path: CodeComplexValue<number>): CodeComplexValue<number>[] => {

  if (!path || codes.some(code => code.value === path.value)) {
    return codes;
  }

  return [{
    ...path,
    descendants: mergePathWithList(codes, path.descendants && path.descendants[0])
  }];
};

export const mapListToStore = (codeItems: CodeListItemWire[], path: CodeComplexValue<number>): CodeComplexValue<number>[] => {

  const codeList = codeItems && codeItems
    .map(item => ({
      value: item?.code?.v,
      description: item?.code?.d,
      ...(!!item?.disabled && { disabled: new Date(item?.disabled) }),
      ...(item?.code?.ld && { longDescription: item.code.ld }),
      descendants: item.code && item.descendantCount ? [{ value: -1 }] : undefined,
      ...(isDefinedIncludingZero(item.category?.v) && {
        category: {
          value: item.category.v,
          description: item.category.d
        }
      })
    })) || [] as CodeComplexValue<number>[];

  return mergePathWithList(codeList, path);
};

export const mapCurrentOptions = (codeItems: CodeListItemWire[]): CodeComplexValue<number>[] => {

  return codeItems && codeItems
    .map(item => {

      return {
        value: item.code && item.code.v
      };
    }) || [] as CodeComplexValue<number>[];
};

export const mapCategoryOptions = (options: Value[]) => options.map(code => { return { code } });
